import { gql } from '@apollo/client';

export const CREATE_CREDIT_DONATION = gql`
    mutation CreateCreditDonation($credits: Float!, $pointType: Boolean) {
        createCreditDonation(credits: $credits, pointType: $pointType)
    }
`;
